import moment from 'moment';
import { useState } from 'react';

import {
    Box,
    Button,
    Checkbox,
    Dropdown,
    Icon,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Text,
} from 'shell/components';
import { getPrettyFileSize } from 'utils/helper';

const data1 = [
    {
        id: '1',
        title: 'Peer Evaluation #1',
        status: 'published',
        start_on: 1662015600000,
        end_on: 1664607600000,
        due_on: 1663484400000,
        completion: '88/101',
    },
    {
        id: '2',
        title: 'Peer Evaluation #2',
        status: 'draft',
        start_on: 1668240000000,
        end_on: 1669881600000,
        due_on: 1669190400000,
        completion: '-',
    },
];

const data2 = [
    {
        id: '1',
        title: 'Marketing Research Title Largest Space Taken.pdf',
        type: 'file',
        owner: 'Georgina Watson',
        created_on: 1664607600000,
        size: 451000,
    },
    {
        id: '2',
        title: 'Research Article',
        type: 'link',
        owner: 'Georgina Watson',
        created_on: 1662015600000,
        size: 0,
    },
];

const TableDemo = () => {
    const [checkedFiles, setCheckedFiles] = useState([]);

    const mapStatus = (status) => {
        if (status === 'published') {
            return (
                <Stack direction={'row'} spacing={2}>
                    <Icon sx={{ fontSize: 'inherit' }} kind={'fileUploaded'} />
                    Published
                </Stack>
            );
        }
        if (status === 'draft') {
            return (
                <Stack direction={'row'} spacing={2}>
                    <Icon sx={{ fontSize: 'inherit' }} kind={'save'} />
                    Saved as Draft
                </Stack>
            );
        }
    };

    const mapType = (type) => {
        if (type === 'file') {
            return 'PDF Document';
        }
        if (type === 'link') {
            return 'Website Link';
        }
    };

    const getOwner = (owner) => {
        return owner;
    };

    return (
        <>
            <Text variant={'sh1'}>Table</Text>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Due Date</TableCell>
                        <TableCell>Availability</TableCell>
                        <TableCell>Completion</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data1.map((d) => (
                        <TableRow key={d.id} onClick={console.log}>
                            <TableCell>{d.title}</TableCell>
                            <TableCell>{mapStatus(d.status)}</TableCell>
                            <TableCell>{moment(d.due_on).format('MMM D [at] hh:mma')}</TableCell>
                            <TableCell>
                                {moment(d.start_on).format('MMM D [at] hh:mma')} -{' '}
                                {moment(d.end_on).format('MMM D [at] hh:mma')}
                            </TableCell>
                            <TableCell>
                                <Box sx={{ display: 'inline-flex', width: '50px' }}>{d.completion}</Box>
                                <Button
                                    disabled={d.completion === '-'}
                                    variant={'tertiary'}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    View Submissions
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Dropdown
                                    id={`table-dropdown-${d.id}`}
                                    options={[
                                        { key: 'edit', value: 'Edit' },
                                        ...(d.status === 'published' ? [{ key: 'unpublish', value: 'Unpublish' }] : []),
                                        { key: 'delete', value: 'Delete' },
                                    ]}
                                    rootComponent={
                                        <IconButton
                                            kind={'moreHorizontal'}
                                            size={'medium'}
                                            variant={'square'}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                    }
                                    onSelect={console.log}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ paddingRight: 0 }}>
                            <Checkbox
                                checked={data2.every(({ id }) => checkedFiles.includes(id))}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setCheckedFiles(data2.map(({ id }) => id));
                                    } else {
                                        setCheckedFiles([]);
                                    }
                                }}
                            />
                        </TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Owner</TableCell>
                        <TableCell>Uploaded</TableCell>
                        <TableCell>Size</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data2.map((d) => (
                        <TableRow key={d.id}>
                            <TableCell sx={{ paddingRight: 0 }}>
                                <Checkbox
                                    checked={checkedFiles.includes(d.id)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setCheckedFiles((current) => [...current, d.id]);
                                        } else {
                                            setCheckedFiles((current) => current.filter((item) => item !== d.id));
                                        }
                                    }}
                                />
                            </TableCell>
                            <TableCell>{d.title}</TableCell>
                            <TableCell>{mapType(d.type)}</TableCell>
                            <TableCell>{getOwner(d.owner)}</TableCell>
                            <TableCell>{moment(d.created_on).format('MMM D [at] hh:mma')}</TableCell>
                            <TableCell>{d.type === 'file' ? getPrettyFileSize(d.size) : '-'}</TableCell>
                            <TableCell>
                                <IconButton kind={'download'} size={'medium'} variant={'square'} />
                                <IconButton kind={'delete'} size={'medium'} variant={'square'} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
};

export default TableDemo;
